import React from 'react';

class rowItem extends React.PureComponent {
    render() {
        let cells = ""
        if (this.props.type === "header") {
            cells =   <React.Fragment> 
                <th scope="col" className={this.props.className[0]} colSpan={this.props.span[0]}>{this.props.text[0]}</th>
                <th scope="col" className={this.props.className[1]} colSpan={this.props.span[1]}>{this.props.text[1]}</th>
                <th scope="col" className={this.props.className[2]} colSpan={this.props.span[2]}>{this.props.text[2]}</th>
                </React.Fragment>
            }
            else if(this.props.type ==="summary"){
                cells =   <React.Fragment> 
                <td scope="row" className={this.props.className[0]} colSpan={this.props.span[0]}>{this.props.text[0]}</td>
                <td scope="row" className={this.props.className[1]} colSpan={this.props.span[1]}>{this.props.text[1]}</td>                
                </React.Fragment>
            }
        else {
            cells =   <React.Fragment>
                <td scope="row" className={this.props.className[0]} colSpan={this.props.span[0]}>{this.props.text[0]}</td>
                <td scope="row" className={this.props.className[1]} colSpan={this.props.span[1]}>{this.props.text[1]}</td>
                <td scope="row" className={this.props.className[2]} colSpan={this.props.span[2]}>{this.props.text[2]}</td>
                   </React.Fragment>
            }
        return (
            <React.Fragment>
                <tr className={this.props.rowclassName} data-cs-mask={this.props.datacsmask}>
                    {cells}
                </tr>
            </React.Fragment>
        )
    }
}

export default rowItem;